import React, {
  useMemo, memo, useCallback,
} from 'react';
import Drawer from '@mui/material/Drawer';
import find from 'lodash/find';
import LinearProgress from '@mui/material/LinearProgress';
import { useHistory } from 'react-router-dom';

import { useNavigation } from '../../navigation/hooks';
import {
  LogoToolbar,
  Logo,
  DrawerListItem,
  DrawerListItemText,
} from './styled';
import LinkList from './LinkList';
import { signOut, useUser } from '../../auth';

function PermanentDrawerLeft ({ show }) {
  const user = useUser();
  const { getLinks } = useNavigation();
  const links = getLinks()
    .sort((a, b) => a.index - b.index);
  const linksAsTree = makeTree(links);
  const authText = user && user.effectiveUser
    ? `Sign out ${user.ghostedUsername ? '👻' : ''}${user.authUser && user.authUser.username}`
    : 'Authenticating ...';
  const { push } = useHistory();
  const handleSignOut = useCallback(async () => {
    user.setPassword(null);
    user.signInAs(null);
    await signOut();
    push('/login');
  }, [user]);

  return useMemo(() => (show &&
    <Drawer>
      <LogoToolbar>
        <Logo/>
      </LogoToolbar>
      <LogoToolbar>
        <DrawerListItem button onClick={handleSignOut}>
          <DrawerListItemText title={authText}>{authText}</DrawerListItemText>
        </DrawerListItem>
      </LogoToolbar>
      <LinkList links={linksAsTree} open/>
    </Drawer>
  ), [show, links, user]);
}

export default memo(PermanentDrawerLeft);

const makeTree = links => links
  .reduce((result, { label, path, iconComponent, menuItem }) => {
    const parts = label.split('/');
    let parent = result;
    for (let i = 0; i < parts.length - 1; i++) {
      const nextParent = find(parent, { label: parts[i] });
      if (nextParent) {
        parent = nextParent.children;
      } else {
        parent.push({
          label: parts[i],
          path: '#',
          iconComponent: null,
          children: [],
        });
        parent = parent[parent.length - 1].children;
      }
    }
    parent.push({ label: parts[parts.length - 1], path, iconComponent });
    return result;
  }, []);

/*
const mapStateToProps = ({ sampleList }) => ({
  list: sampleList,
})

export default connect(mapStateToProps)(PermanentDrawerLeft);
*/